module.exports = __webpack_public_path__ + "static/img/sdslzyxy.ee989357.png";